export default __webpack_public_path__ + "static/media/User.dfaaddb5.png";